<div class="flex gap-2 flex-col">
    @for (field of fieldsArray(); track field.guid) {
        @if (!inactiveFieldsObject()[field.guid]) {
            <div class="flex gap-2 w-full h-full">
                <app-tb-icon color="textLight" [icon]="fieldsIcons()[field.guid]"></app-tb-icon>
                <div class="flex">
                    <span>{{ field.name }}</span>
                </div>
            </div>
        }
    }
</div>
